module.exports = __webpack_public_path__ + "static/media/chrisobdam.d3cc8be5.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/chrisobdam.webp
// module id = 444
// module chunks = 0